import i18nMixin from '../i18nMixin';
import * as landRegistryActions from '../../actions/landRegistry';
import authMixin from '../authMixin';
import landRegistryStore from '../../stores/landRegistry';

export const init = (tag): void => {
  tag.mixin(authMixin);
  tag.mixin(i18nMixin);

  tag.formSubmit = (event: Event): void => {
    event.preventDefault();
    const cadastreKey = tag.refs.cadastreKeyInput.value.trim();
    const state = tag.refs.stateSelect.value.trim();
    landRegistryActions.retrieveLandRegistry('ENCUMBRANCES', cadastreKey, state);
    landRegistryActions.retrieveLandRegistry('EASEMENTS', cadastreKey, state);
    landRegistryActions.retrieveLandRegistry('TITLES', cadastreKey, state);
    landRegistryActions.retrieveLandRegistry('LANDDATA', cadastreKey, state);
    landRegistryActions.retrieveLandRegistry('MONETARY_ENCUMBRANCES', cadastreKey, state);
    landRegistryActions.retrieveLandRegistry('PRIVILEGES', cadastreKey, state);
    tag.update();
  };

  const updateState = (): void => {
    tag.cadastreKey = landRegistryStore.getState().lastQuery.key;
    tag.refs.stateSelect.value = landRegistryStore.getState().lastQuery.eventState;
    tag.update();
  };

  tag.on('mount', () => {
    updateState();
    landRegistryStore.subscribe(updateState);
  });

  tag.on('unmount', () => {
    landRegistryStore.unsubscribe(updateState);
  });
};
